import NewslettersForm from './NewslettersForm';
import ModalNewsletterForm from './ModalNewsletterForm';

export default NewslettersForm;

export {
    ModalNewsletterForm
}
